/**
 * The preview gate. Learn is built and deployed but not open: the rail shows a
 * "PRE" badge and the page explains itself instead of starting a round.
 *
 * The unlock is a URL the team can carry rather than a build flag, so turning
 * it on for a demo does not need a deploy: `/learn?preview=1` unlocks and
 * remembers; `/learn?preview=0` locks again. This is a soft gate on a paid,
 * server-metered feature — it hides an unfinished surface from people who
 * aren't looking for it. It is NOT a security boundary, and it isn't pretending
 * to be one: the server's entitlement check is what actually protects the
 * paid rounds and the transcription spend.
 */
const KEY = 'baba.learn.preview'

export function isLearnPreviewUnlocked(): boolean {
  try {
    return localStorage.getItem(KEY) === '1'
  } catch {
    return false
  }
}

/** Consume `?preview=1|0` if present. Returns the resulting unlocked state. */
export function applyPreviewParam(search: string): boolean {
  const v = new URLSearchParams(search).get('preview')
  if (v === '1' || v === '0') {
    try {
      localStorage.setItem(KEY, v)
    } catch {
      // private mode: the unlock lasts for this page only
    }
    return v === '1'
  }
  return isLearnPreviewUnlocked()
}
